<template>
    <div @click="SelectImage">
        <slot></slot>
        <div :id="nameControl" :class="nameControl + ' d-none '">
            <input :id="nameControl + '_file'" type="file" @change="PreviewArchivo"/>
        </div>
    </div>
</template>
<script setup lang="ts">
import { defineProps, defineEmits, ref } from 'vue';
const emits = defineEmits(['onSetFile','onPreview']); 
const props = defineProps({
edicion:
{
    type: Boolean,
    default: false,
    required:true
},
nameControl:
{
    type: String,
    default: "inpImgSelectCtrl"
}});
const image = ref<any>();
const hasImage = ref<boolean>(false);
const SelectImage =()=>
{    
    if (props.edicion)
    {
      const file = document.getElementById(props.nameControl + '_file'); 
      if(file)
      {        
        file.click();
      }
    }
}
const PreviewArchivo = (event:any)=>
{   
    const inp = event.target;
    if (inp.files && inp.files[0]) 
    {
        const reader = new FileReader();
        reader.onload = (e: any) =>
        {
            image.value = e.target.result;              
            emits('onPreview',e.target.result);        
        };
        reader.readAsDataURL(inp.files[0]);
        hasImage.value = true;
        emits('onSetFile',inp.files[0]);        
    }
    else
    {
        image.value = '';
        hasImage.value = false;
    }
}
</script>